/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  error400PageNotAvailableTitle: {
    id: 'IEGPageNotAvailable_error400PageNotAvailableTitle',
    defaultMessage: 'This page is no longer available'
  },
  error400PageNotAvailableDescription: {
    id: 'IEGPageNotAvailable_error400PageNotAvailableDescription',
    defaultMessage: '{refreshPageLink} the form to continue.'
  },
  error400PageNotAvailableResume: {
    id: 'IEGPageNotAvailable_error400PageNotAvailableResume',
    defaultMessage: 'Resume'
  }
});